  const title = {
    fontSizeMobile: '24px',
    lineHeightMobile: '30px',
    fontWeight: '325',
    textTransform: 'none',
    fontSizeDesktop: '32px',
    lineHeightDesktop: '40px',
    fontSizeMobileProductsGrid: '24px',
    lineHeightMobileProductsGrid: '30px',
  }
  
  const cta = {
    fontWeight: '400',
    lineHeight: '17.5px',
    letterSpacing: '0.14px'
  }
  
  const paragraph = {
    fontWeight: '325',
    fontSize: '16px',
    lineHeight: '24px'
  }
  
  const loyaltyBanner = {
    title,
    cta,
    paragraph
  }
  export default loyaltyBanner